import { render, staticRenderFns } from "./SelectricWrapper.vue?vue&type=template&id=1ac01375&"
import script from "./SelectricWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectricWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports